import { ROUTE_DASHBOARD, ROUTE_SIGN_IN } from '@/constants/routes';
import authService from '@/services/auth.service';
import { hasWorkosSession } from '@/services/workos-auth-bridge';
import { isBounceReason } from '@/utils/routing/sign-in-bounce';
import { RouteObject, redirect } from 'react-router-dom';
import Page from './sign-in.page';

// DO NOT DELETE OR INLINE: this route is registered as the WorkOS "Initiate
// Login URI" for impersonation. WorkOS dashboard impersonation lands here
// first so AuthKit can establish PKCE state via signIn() before bouncing back
// with a `code`. Without this route, the AuthKit hosted page returns an
// undefined RSC action and impersonation silently hangs.
export const routeSignIn: RouteObject = {
  path: ROUTE_SIGN_IN,
  loader({ request }) {
    // ?reason=no_account / ?reason=already_member are deliberate interstitial
    // landings; the WorkOS session may still be active and we must NOT bounce
    // to /dashboard, or we restart the orphan-bounce loop.
    const reason = new URL(request.url).searchParams.get('reason');
    if (isBounceReason(reason)) {
      return null;
    }
    if (authService.isLoggedIn() || hasWorkosSession()) {
      return redirect(ROUTE_DASHBOARD);
    }
    return null;
  },
  Component: Page,
};
